import React from "react";

const VideoRow = ({
  videoLink,
  title,
  description,
  backgroundColor,
  dateStamp,
}) => {
  return (
    <div className="videoRow" style={{ backgroundColor: backgroundColor }}>
      <iframe
        className="video"
        title={title}
        src={videoLink}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        allowFullScreen
      ></iframe>
      <h5 className="videoTitle">{title}</h5>
      <div
        className="customHl"
        style={{ gridArea: "title", borderColor: "#494848" }}
      />
      <p className="videoDate">{dateStamp}</p>
      <p className="videoDescription">{description}</p>
    </div>
  );
};

export default VideoRow;
